import React from 'react';

import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { SimTypography } from 'components/SimTypography';
import Container from '@mui/material/Container';

import Page from './Page';
import { ABATherapyDescription, ABATherapySummary, ABATherapyVideoScroll } from './ABATherapy';
import {
	SpeechLangTherapyDescription,
	SpeechLangTherapySummary,
	SpeechLangTherapyVideoScroll
} from './SpeechLangTherapy';
import {
	FeedingOccuTherapyDescription,
	FeedingOccuTherapySummary,
	FeedingOccuTherapyVideoScroll
} from './FeedingOccupationalTherapy';

import { CouplesTherapyDescription, CouplesTherapySummary, CouplesTherapyVideoScroll } from './CouplesTherapy';

const AllTherapies = () => {
	const theme = useTheme();

	return (
		<Box>
			<Page>
				<Box sx={{ boxShadow: 0 }} marginTop={'25px'} marginX={0}>
					{/* START SUBHEADER */}
					<Box paddingY={'20px'}>
						<Container>
							<SimTypography
								sx={{
									textTransform: 'uppercase',
									fontWeight: 'medium'
								}}
								gutterBottom
								color={'secondary'}
								align={'left'}>
								OUR FOUNDERS' NOTE
							</SimTypography>
							<SimTypography
								variant='h6'
								align={'left'}
								sx={{
									fontWeight: 700,
									fontStyle: 'italic'
								}}>
								Selecting the right therapy service is never an easy decision. We've been there.
								<br />
								Our therapy services catalogue & resource library will help you get a better experience
								than we did.
							</SimTypography>
						</Container>
					</Box>
					{/* END SUBHEADER */}

					<Box
						id='dividerFinal'
						height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
						marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
						<Box
							height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
							component={'svg'}
							preserveAspectRatio='none'
							xmlns='http://www.w3.org/2000/svg'
							x='0px'
							y='0px'
							viewBox='0 0 1920 100.1'
							sx={{
								marginBottom: -1,
								width: 1
							}}>
							<path fill={theme.palette.divider.dark} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
						</Box>
					</Box>

					<Box id='ANCHOR_Therapy_ABATherapy'>
						<ABATherapySummary />
						<ABATherapyDescription />
						<ABATherapyVideoScroll />
					</Box>

					<Box
						id='dividerFinal'
						height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
						marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
						<Box
							height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
							component={'svg'}
							preserveAspectRatio='none'
							xmlns='http://www.w3.org/2000/svg'
							x='0px'
							y='0px'
							viewBox='0 0 1920 100.1'
							sx={{
								marginBottom: -1,
								width: 1
							}}>
							<path fill={theme.palette.divider.dark} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
						</Box>
					</Box>

					<Box id='ANCHOR_Therapy_SpeechTherapy'>
						<SpeechLangTherapySummary />
						<SpeechLangTherapyDescription />
						<SpeechLangTherapyVideoScroll />
					</Box>

					<Box
						id='dividerFinal'
						height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
						marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
						<Box
							height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
							component={'svg'}
							preserveAspectRatio='none'
							xmlns='http://www.w3.org/2000/svg'
							x='0px'
							y='0px'
							viewBox='0 0 1920 100.1'
							sx={{
								marginBottom: -1,
								width: 1
							}}>
							<path fill={theme.palette.divider.dark} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
						</Box>
					</Box>

					<Box id='ANCHOR_Therapy_FeedingOccuTherapy'>
						<FeedingOccuTherapySummary />
						<FeedingOccuTherapyDescription />
						<FeedingOccuTherapyVideoScroll />
					</Box>

					<Box
						id='dividerFinal'
						height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
						marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
						<Box
							height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
							component={'svg'}
							preserveAspectRatio='none'
							xmlns='http://www.w3.org/2000/svg'
							x='0px'
							y='0px'
							viewBox='0 0 1920 100.1'
							sx={{
								marginBottom: -1,
								width: 1
							}}>
							<path fill={theme.palette.divider.dark} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
						</Box>
					</Box>

					<Box id='ANCHOR_Therapy_CouplesTherapy'>
						<CouplesTherapySummary />
						<CouplesTherapyDescription />
						<CouplesTherapyVideoScroll />
					</Box>
				</Box>
			</Page>
		</Box>
	);
};

export { AllTherapies };
